import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatDateTime } from '../utils/dashboardTranslations';

function Vendors() {
    const [vendors, setVendors] = useState([]);
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showCredentialsModal, setShowCredentialsModal] = useState(false);
    const [selectedVendorCredentials, setSelectedVendorCredentials] = useState(null);
    const [selectedVendorId, setSelectedVendorId] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [form, setForm] = useState({
        name: '',
        phoneNumber: '',
        password: '',
        location: '',
        governorate: '',
        city: '',
        latitude: null,
        longitude: null,
        dollarExchangeRate: '',
        vendorCategoryId: '',
        imageFile: null,
        openingTime: '',
        closingTime: '',
        deliveryTimeMinutes: '',
        discountPercentage: '',
        discountStartDate: '',
        discountEndDate: ''
    });
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);
    const [categories, setCategories] = useState([]);

    // --- Global Store Override state ---
    const [globalOverride, setGlobalOverride] = useState(null);
    const [overrideForm, setOverrideForm] = useState({
        isAllVendorsClosed: false,
        reason: '',
        untilUtc: ''
    });
    const [overrideMessage, setOverrideMessage] = useState(null); // { type: 'success'|'danger', text: string }
    const [overrideLoading, setOverrideLoading] = useState(false);
    // ------------------------------------

    useEffect(() => {
        fetchVendors();
        fetchCategories();
        fetchGlobalOverride();
    }, []);

    useEffect(() => {
        filterVendors();
    }, [searchQuery, vendors]);

    // --- Global Override helpers ---
    const fetchGlobalOverride = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await api.get('/vendor-availability/global-override', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setGlobalOverride(res.data || null);
        } catch (err) {
            // 404 means no active override — treat as null
            if (err?.response?.status === 404) {
                setGlobalOverride(null);
            } else {
                console.error('Failed to fetch global override:', err);
            }
        }
    };

    const handleApplyOverride = async (e) => {
        e.preventDefault();
        setOverrideLoading(true);
        setOverrideMessage(null);
        try {
            const token = localStorage.getItem('token');
            await api.put(
                '/vendor-availability/global-override',
                {
                    isAllVendorsClosed: overrideForm.isAllVendorsClosed,
                    reason: overrideForm.reason.trim() || null,
                    untilUtc: overrideForm.untilUtc
                        ? new Date(overrideForm.untilUtc).toISOString()
                        : null
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            await fetchGlobalOverride();
            setOverrideMessage({ type: 'success', text: 'تم تطبيق الإعداد العام بنجاح.' });
        } catch (err) {
            console.error('Failed to apply global override:', err);
            setOverrideMessage({
                type: 'danger',
                text: 'فشل تطبيق الإعداد العام: ' + (err?.response?.data?.message || err.message)
            });
        } finally {
            setOverrideLoading(false);
        }
    };

    const handleClearOverride = async () => {
        if (!window.confirm('هل أنت متأكد من إلغاء الإعداد العام للمتاجر؟')) return;
        setOverrideLoading(true);
        setOverrideMessage(null);
        try {
            const token = localStorage.getItem('token');
            await api.delete('/vendor-availability/global-override', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setGlobalOverride(null);
            setOverrideMessage({ type: 'success', text: 'تم إلغاء الإعداد العام بنجاح.' });
        } catch (err) {
            console.error('Failed to clear global override:', err);
            setOverrideMessage({
                type: 'danger',
                text: 'فشل إلغاء الإعداد العام: ' + (err?.response?.data?.message || err.message)
            });
        } finally {
            setOverrideLoading(false);
        }
    };
    // --------------------------------

    const filterVendors = () => {
        // Ensure vendors is an array before filtering
        if (!Array.isArray(vendors)) {
            setFilteredVendors([]);
            return;
        }

        if (!searchQuery.trim()) {
            setFilteredVendors(vendors);
        } else {
            const filtered = vendors.filter(vendor =>
                vendor.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                vendor.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (vendor.governorate && vendor.governorate.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (vendor.city && vendor.city.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (vendor.phoneNumber && vendor.phoneNumber.toLowerCase().includes(searchQuery.toLowerCase())) ||
                (vendor.vendorCategory?.name && vendor.vendorCategory.name.toLowerCase().includes(searchQuery.toLowerCase()))
            );
            setFilteredVendors(filtered);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        filterVendors();
    };
    const handleMoveUp = async (id) => {
        try {
            await api.patch(`/Vendor/${id}/move-up`);
            fetchVendors();
        } catch (err) {
            if (err?.response?.status !== 400) {
                alert('فشل تغيير الترتيب');
            }
        }
    };

    const handleMoveDown = async (id) => {
        try {
            await api.patch(`/Vendor/${id}/move-down`);
            fetchVendors();
        } catch (err) {
            if (err?.response?.status !== 400) {
                alert('فشل تغيير الترتيب');
            }
        }
    };

    const handleDeleteVendor = async (vendorId) => {
        const confirmDelete = window.confirm('هل أنت متأكد من حذف هذا المتجر؟');
        if (!confirmDelete) return;

        try {
            const token = localStorage.getItem('token');
            await api.delete(`/Vendor/${vendorId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            alert('تم حذف المتجر بنجاح');
            setVendors((prev) => prev.filter((v) => v.id !== vendorId));
        } catch (err) {
            console.error('Delete error details:', err);
            console.error('Error response:', err?.response?.data);
            console.error('Error status:', err?.response?.status);
            
            let errorMessage = 'فشل حذف المتجر';
            if (err?.response?.data?.message) {
                errorMessage += ': ' + err.response.data.message;
            } else if (err?.response?.status === 409) {
                errorMessage = 'لا يمكن حذف المتجر لأنه يحتوي على منتجات أو طلبات مرتبطة به';
            } else if (err?.response?.status === 401) {
                errorMessage = 'غير مصرح لك بحذف هذا المتجر';
            }
            
            alert(errorMessage);
        }
    };



    const fetchVendors = async () => {
        try {
            setLoading(true);
            const res = await api.get('/Vendor');
            console.log('Vendors response:', res.data);
            
            // Handle different response structures
            let vendorsData = [];
            if (Array.isArray(res.data)) {
                vendorsData = res.data;
            } else if (res.data && res.data.vendors && Array.isArray(res.data.vendors)) {
                vendorsData = res.data.vendors;
            } else {
                console.error('Unexpected vendors response structure:', res.data);
                vendorsData = [];
            }
            
            setVendors(vendorsData);
            setFilteredVendors(vendorsData); // Initialize filtered vendors
        } catch (err) {
            console.error('Failed to fetch vendors:', err);
            alert('فشل تحميل البائعين');
            setVendors([]);
            setFilteredVendors([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchVendorCredentials = async (vendorId) => {
        try {
            const response = await api.get(`/Vendor/${vendorId}/credentials`);
            setSelectedVendorCredentials(response.data);
            setSelectedVendorId(vendorId); // Store the vendor ID separately
            setShowCredentialsModal(true);
        } catch (error) {
            console.error('Failed to fetch vendor credentials:', error);
            alert('Error fetching vendor credentials');
        }
    };

    const resetVendorPassword = async () => {
        if (!newPassword.trim()) {
            alert('Please enter a new password');
            return;
        }

        if (!selectedVendorId) {
            alert('No vendor selected');
            return;
        }

        try {
            await api.post(`/Vendor/${selectedVendorId}/reset-password`, { 
                newPassword 
            });
            alert('Password reset successfully');
            setNewPassword('');
            setShowCredentialsModal(false);
            setSelectedVendorId(null); // Clear the selected vendor ID
            fetchVendors(); // Refresh the list
        } catch (error) {
            console.error('Failed to reset password:', error);
            alert('Error resetting password');
        }
    };


    const fetchCategories = async () => {
        try {
            console.log('🔍 Fetching categories...');
            console.log('API URL:', process.env.REACT_APP_API_URL);
            
            const res = await api.get('/VendorCategory');
            console.log('✅ Raw response:', res);
            console.log('✅ Response data:', res.data);
            console.log('📊 Response data type:', typeof res.data);
            console.log('📊 Is response array?:', Array.isArray(res.data));
            
            // Handle different response structures
            let categoriesData = [];
            
            if (Array.isArray(res.data)) {
                categoriesData = res.data;
            } else if (res.data && res.data.categories && Array.isArray(res.data.categories)) {
                categoriesData = res.data.categories;
            } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
                categoriesData = res.data.data;
            } else if (res.data && typeof res.data === 'object') {
                // If it's an object, try to extract any array property
                const keys = Object.keys(res.data);
                console.log('📊 Response object keys:', keys);
                for (const key of keys) {
                    if (Array.isArray(res.data[key])) {
                        categoriesData = res.data[key];
                        console.log(`📊 Found array in property: ${key}`);
                        break;
                    }
                }
            }
            
            console.log('📊 Final categories data:', categoriesData);
            console.log('📊 Categories count:', categoriesData.length);
            
            setCategories(categoriesData);
            
            if (categoriesData.length === 0) {
                console.warn('⚠️ No categories found in response');
            }
        } catch (error) {
            console.error('❌ Failed to fetch categories:', error);
            console.error('❌ Error details:', error.response?.data);
            console.error('❌ Error status:', error.response?.status);
            
            // Set empty array on error to prevent map error
            setCategories([]);
            alert('فشل في تحميل الفئات: ' + (error.response?.data?.message || error.message));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', form.name);
        formData.append('phoneNumber', form.phoneNumber);
        formData.append('password', form.password);
        formData.append('location', form.location);
        formData.append('governorate', form.governorate);
        formData.append('city', form.city);
        if (form.latitude !== null && form.latitude !== '') formData.append('Latitude', form.latitude);
        if (form.longitude !== null && form.longitude !== '') formData.append('Longitude', form.longitude);
        formData.append('dollarExchangeRate', form.dollarExchangeRate);
        formData.append('vendorCategoryId', form.vendorCategoryId);
        if (form.openingTime) formData.append('OpeningTime', form.openingTime);
        if (form.closingTime) formData.append('ClosingTime', form.closingTime);
        if (form.deliveryTimeMinutes) formData.append('DeliveryTimeMinutes', form.deliveryTimeMinutes);
        if (form.discountPercentage !== '') formData.append('DiscountPercentage', form.discountPercentage);
        if (form.discountStartDate) formData.append('DiscountStartDate', form.discountStartDate);
        if (form.discountEndDate) formData.append('DiscountEndDate', form.discountEndDate);
        if (form.imageFile) formData.append('image', form.imageFile);
        try {
            if (selectedId) {
                await api.put(`/Vendor/${selectedId}/with-image`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.post('/Vendor/with-image', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }
            setForm({
                name: '',
                phoneNumber: '',
                password: '',
                location: '',
                governorate: '',
                city: '',
                latitude: null,
                longitude: null,
                dollarExchangeRate: '',
                vendorCategoryId: '',
                imageFile: null,
                openingTime: '',
                closingTime: '',
                deliveryTimeMinutes: '',
                discountPercentage: '',
                discountStartDate: '',
                discountEndDate: ''
            });
            setSelectedId(null);
            fetchVendors();
        } catch (error) {
            alert('فشل حفظ البائع');
            console.error(error);
        }
    };


    const handleEdit = (v) => {
        // Format time values for HTML time input (HH:mm format)
        const formatTimeForInput = (timeValue) => {
            if (!timeValue) return '';
            
            // If it's already in HH:mm format, return as is
            if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}$/)) {
                return timeValue;
            }
            
            // If it's in HH:mm:ss format, remove seconds
            if (typeof timeValue === 'string' && timeValue.match(/^\d{2}:\d{2}:\d{2}/)) {
                return timeValue.substring(0, 5);
            }
            
            return timeValue;
        };

        setForm({
            name: v.name,
            location: v.location,
            governorate: v.governorate || '',
            city: v.city || '',
            latitude: v.latitude ?? null,
            longitude: v.longitude ?? null,
            dollarExchangeRate: v.dollarExchangeRate,
            vendorCategoryId: v.vendorCategoryId,
            phoneNumber: v.phoneNumber || '',
            password: '', // Don't show password in edit
            imageFile: null,
            openingTime: formatTimeForInput(v.openingTime),
            closingTime: formatTimeForInput(v.closingTime),
            deliveryTimeMinutes: v.deliveryTimeMinutes || '',
            discountPercentage: v.discountPercentage ?? '',
            discountStartDate: v.discountStartDate ? String(v.discountStartDate).slice(0, 10) : '',
            discountEndDate: v.discountEndDate ? String(v.discountEndDate).slice(0, 10) : ''
        });
        setSelectedId(v.id);
    };

    // Helper to get full image URL
   const getImageUrl = (url) => {
    if (!url) return '';
    // Remove :5000 if present, always use main HTTP port
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url.replace(':5000', '');
    }
    // If it's a relative path, add the host from environment
    const apiBase = (process.env.REACT_APP_API_URL || '').replace('/api', '');
    return apiBase + url;
};



    return (
        <div>
            <h4 className="mb-3">إدارة البائعين</h4>

            {/* ============================================================
                GLOBAL STORE OVERRIDE CONTROL
                ============================================================ */}
            <div className="card mb-4 border-secondary">
                <div className="card-header bg-secondary text-white d-flex align-items-center">
                    <strong>&#x1F6E1; التحكم العام بالمتاجر</strong>
                </div>
                <div className="card-body">

                    {/* Feedback message after an action */}
                    {overrideMessage && (
                        <div className={`alert alert-${overrideMessage.type} alert-dismissible`} role="alert">
                            {overrideMessage.text}
                            <button
                                type="button"
                                className="btn-close"
                                onClick={() => setOverrideMessage(null)}
                            ></button>
                        </div>
                    )}

                    {/* Current status banner */}
                    {globalOverride && globalOverride.isAllVendorsClosed ? (
                        <div className="alert alert-danger" role="alert">
                            <strong>&#9888; جميع المتاجر مغلقة حاليًا على مستوى النظام</strong>
                            {globalOverride.reason && (
                                <div className="mt-1">
                                    <strong>السبب:</strong> {globalOverride.reason}
                                </div>
                            )}
                            {globalOverride.untilUtc && (
                                <div className="mt-1">
                                    <strong>حتى:</strong> {formatDateTime(globalOverride.untilUtc)}
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="alert alert-success" role="alert">
                            &#10003; جميع المتاجر تعمل بشكل طبيعي
                        </div>
                    )}

                    {/* Override form */}
                    <form onSubmit={handleApplyOverride}>
                        <div className="row align-items-end">
                            <div className="col-md-3 mb-2">
                                <div className="form-check mt-2">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="overrideCloseAll"
                                        checked={overrideForm.isAllVendorsClosed}
                                        onChange={(e) =>
                                            setOverrideForm({ ...overrideForm, isAllVendorsClosed: e.target.checked })
                                        }
                                    />
                                    <label className="form-check-label" htmlFor="overrideCloseAll">
                                        إغلاق جميع المتاجر
                                    </label>
                                </div>
                            </div>

                            <div className="col-md-4 mb-2">
                                <label className="form-label mb-1">السبب (اختياري)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="مثال: عطلة رسمية"
                                    value={overrideForm.reason}
                                    onChange={(e) =>
                                        setOverrideForm({ ...overrideForm, reason: e.target.value })
                                    }
                                />
                            </div>

                            <div className="col-md-3 mb-2">
                                <label className="form-label mb-1">الإغلاق حتى (اختياري)</label>
                                <input
                                    type="datetime-local"
                                    className="form-control"
                                    value={overrideForm.untilUtc}
                                    onChange={(e) =>
                                        setOverrideForm({ ...overrideForm, untilUtc: e.target.value })
                                    }
                                />
                            </div>

                            <div className="col-md-2 mb-2 d-flex gap-2">
                                <button
                                    type="submit"
                                    className="btn btn-warning"
                                    disabled={overrideLoading}
                                >
                                    {overrideLoading ? 'جارٍ التطبيق...' : 'تطبيق الإعداد'}
                                </button>
                            </div>
                        </div>

                        {/* Clear Override button — only shown when there is an active override */}
                        {globalOverride && globalOverride.isAllVendorsClosed && (
                            <div className="mt-2">
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    disabled={overrideLoading}
                                    onClick={handleClearOverride}
                                >
                                    {overrideLoading ? 'جارٍ المعالجة...' : 'إلغاء الإعداد'}
                                </button>
                            </div>
                        )}
                    </form>

                </div>
            </div>
            {/* ============================================================
                END GLOBAL STORE OVERRIDE CONTROL
                ============================================================ */}

            {loading ? (
                <div className="text-center py-4">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">جاري التحميل...</span>
                    </div>
                    <p className="mt-2">جاري تحميل البائعين...</p>
                </div>
            ) : (
                <>
            {/* Search Bar */}
            <div className="mb-3">
                <form onSubmit={handleSearch} className="d-flex">
                    <input
                        type="text"
                        className="form-control me-2"
                        placeholder="البحث عن البائعين (الاسم، الموقع، رقم الهاتف، الفئة)"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <button type="submit" className="btn btn-primary me-2">
                        بحث
                    </button>
                    <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={() => setSearchQuery('')}
                    >
                        إعادة تعيين
                    </button>
                </form>
            </div>

            <form className="mb-4" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-4">
                        <label>اسم البائع</label>
                        <input
                            className="form-control mb-2"
                            placeholder="مثال: محل الشام"
                            value={form.name}
                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label>رقم الجوال</label>
                        <input
                            className="form-control mb-2"
                            placeholder="مثال: 09xxxxxxxxx"
                            value={form.phoneNumber}
                            onChange={(e) => setForm({ ...form, phoneNumber: e.target.value })}
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label>كلمة المرور</label>
                        <input
                            type="password"
                            className="form-control mb-2"
                            placeholder="كلمة مرور البائع"
                            value={form.password}
                            onChange={(e) => setForm({ ...form, password: e.target.value })}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label>الموقع</label>
                        <input
                            className="form-control mb-2"
                            placeholder="مثال: دمشق"
                            value={form.location}
                            onChange={(e) => setForm({ ...form, location: e.target.value })}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label>المحافظة</label>
                        <input
                            className="form-control mb-2"
                            placeholder="مثال: دمشق"
                            value={form.governorate}
                            onChange={(e) => setForm({ ...form, governorate: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>المدينة</label>
                        <input
                            className="form-control mb-2"
                            placeholder="مثال: المزة"
                            value={form.city}
                            onChange={(e) => setForm({ ...form, city: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>خط العرض (Latitude)</label>
                        <input
                            type="number"
                            step="any"
                            className="form-control mb-2"
                            placeholder="مثال: 33.510"
                            value={form.latitude ?? ''}
                            onChange={(e) => setForm({ ...form, latitude: e.target.value ? parseFloat(e.target.value) : null })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>خط الطول (Longitude)</label>
                        <input
                            type="number"
                            step="any"
                            className="form-control mb-2"
                            placeholder="مثال: 36.291"
                            value={form.longitude ?? ''}
                            onChange={(e) => setForm({ ...form, longitude: e.target.value ? parseFloat(e.target.value) : null })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>سعر صرف الدولار</label>
                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="مثال: 15500"
                            value={form.dollarExchangeRate}
                            onChange={(e) => setForm({ ...form, dollarExchangeRate: e.target.value })}
                            required
                        />
                    </div>

                    <div className="col-md-4">
                        <label>وقت الافتتاح</label>
                        <input
                            type="time"
                            className="form-control mb-2"
                            value={form.openingTime}
                            onChange={(e) => setForm({ ...form, openingTime: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>وقت الإغلاق</label>
                        <input
                            type="time"
                            className="form-control mb-2"
                            value={form.closingTime}
                            onChange={(e) => setForm({ ...form, closingTime: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>وقت التوصيل (بالدقائق)</label>
                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="مثال: 30"
                            value={form.deliveryTimeMinutes}
                            onChange={(e) => setForm({ ...form, deliveryTimeMinutes: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>خصم المتجر (%)</label>
                        <input
                            type="number"
                            className="form-control mb-2"
                            placeholder="مثال: 10"
                            min="0"
                            max="99"
                            value={form.discountPercentage}
                            onChange={(e) => setForm({ ...form, discountPercentage: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>تاريخ بداية الخصم</label>
                        <input
                            type="date"
                            className="form-control mb-2"
                            value={form.discountStartDate}
                            onChange={(e) => setForm({ ...form, discountStartDate: e.target.value })}
                        />
                    </div>

                    <div className="col-md-4">
                        <label>تاريخ نهاية الخصم</label>
                        <input
                            type="date"
                            className="form-control mb-2"
                            value={form.discountEndDate}
                            onChange={(e) => setForm({ ...form, discountEndDate: e.target.value })}
                        />
                    </div>

                    <div className="col-md-8">
                        <label>صورة البائع</label>
                        <input
                            type="file"
                            accept="image/*"
                            className="form-control mb-2"
                            onChange={e => setForm({ ...form, imageFile: e.target.files[0] })}
                        />
                    </div>

                    <div className="col-md-6">
                        <label>فئة البائع</label>
                        <select
                            className="form-control mb-2"
                            value={form.vendorCategoryId}
                            onChange={(e) =>
                                setForm({ ...form, vendorCategoryId: parseInt(e.target.value) })
                            }
                            required
                        >
                            <option value="">-- اختر الفئة --</option>
                            {Array.isArray(categories) && categories.map((c) => (
                                <option key={c.id} value={c.id}>
                                    {c.name}
                                </option>
                            ))}
                        </select>
                        
                        {/* Debug info */}
                        <small className="text-muted">
                            Categories loaded: {categories.length} | 
                            Selected: {form.vendorCategoryId || 'none'}
                        </small>
                        
                        {categories.length === 0 && (
                            <div className="alert alert-warning mt-2">
                                ⚠️ لم يتم تحميل أي فئات. تحقق من اتصال الشبكة والـ API.
                            </div>
                        )}
                    </div>

                    <div className="col-md-6 text-end">
                        <button type="submit" className="btn btn-success mt-4">
                            {selectedId ? 'تعديل البائع' : 'إضافة بائع'}
                        </button>
                    </div>
                </div>
            </form>


            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>الترتيب</th>
                        <th>اسم البائع</th>
                        <th>رقم الهاتف</th>
                        <th>حالة تسجيل الدخول</th>
                        <th>الموقع</th>
                        <th>المحافظة</th>
                        <th>المدينة</th>
                        <th>الفئة</th>
                        <th>أوقات العمل</th>
                        <th>وقت التوصيل</th>
                        <th>الخصم</th>
                        <th>صورة البائع</th>
                        <th>إجراءات</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(filteredVendors) && filteredVendors.length === 0 ? (
                        <tr>
                            <td colSpan="12" className="text-center">
                                <div className="alert alert-warning mb-0">
                                    {searchQuery ? 'لم يتم العثور على بائعين' : 'لا يوجد بائعين لعرضهم.'}
                                </div>
                            </td>
                        </tr>
                    ) : (
                        Array.isArray(filteredVendors) && filteredVendors.map((v) => (
                            <tr key={v.id}>
                                <td>
                                    <button className="btn btn-sm btn-secondary me-1" onClick={() => handleMoveUp(v.id)}>▲</button>
                                    <button className="btn btn-sm btn-secondary" onClick={() => handleMoveDown(v.id)}>▼</button>
                                </td>
                                <td>{v.name}</td>
                                <td>{v.phoneNumber || '—'}</td>
                                <td>
                                    {v.phoneNumber ? (
                                        <span className="badge bg-success">تم تعيين بيانات الدخول</span>
                                    ) : (
                                        <span className="badge bg-warning">لم يتم تعيين بيانات الدخول</span>
                                    )}
                                </td>
                                <td>{v.location}</td>
                                <td>{v.governorate || '—'}</td>
                                <td>{v.city || '—'}</td>
                                <td>{v.vendorCategory?.name || 'غير محددة'}</td>
                                <td>
                                    {v.openingTime && v.closingTime ? (
                                        <small>
                                            <strong style={{color: 'green'}}>{v.openingTime}</strong> - <strong style={{color: 'red'}}>{v.closingTime}</strong>
                                        </small>
                                    ) : (
                                        <small className="text-muted">غير محدد</small>
                                    )}
                                </td>
                                <td>
                                    {v.deliveryTimeMinutes ? (
                                        <small><strong style={{color: 'blue'}}>{v.deliveryTimeMinutes} دقيقة</strong></small>
                                    ) : (
                                        <small className="text-muted">غير محدد</small>
                                    )}
                                </td>
                                <td>
                                    {v.discountPercentage ? (
                                        <div>
                                            <span className="badge bg-warning text-dark">{v.discountPercentage}%</span>
                                            <div>
                                                <small className="text-muted">
                                                    {v.discountStartDate ? String(v.discountStartDate).slice(0, 10) : '—'} - {v.discountEndDate ? String(v.discountEndDate).slice(0, 10) : '—'}
                                                </small>
                                            </div>
                                        </div>
                                    ) : (
                                        <small className="text-muted">لا يوجد</small>
                                    )}
                                </td>
                                <td>{v.imageUrl && <img src={getImageUrl(v.imageUrl)} alt={v.name} style={{ width: 50 }} />}</td>
                                <td>
                                    <button
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => navigate(`/dashboard/vendors/${v.id}`)}
                                    >
                                        عرض التفاصيل
                                    </button>
                                    {v.phoneNumber && (
                                        <button
                                            className="btn btn-outline-info btn-sm me-2"
                                            onClick={() => fetchVendorCredentials(v.id)}
                                        >
                                            عرض بيانات الدخول
                                        </button>
                                    )}
                                    <button
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() => handleDeleteVendor(v.id)}
                                    >
                                        حذف
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* Credentials Modal */}
            {showCredentialsModal && selectedVendorCredentials && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">بيانات دخول البائع</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowCredentialsModal(false);
                                        setNewPassword('');
                                        setSelectedVendorId(null);
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label"><strong>اسم البائع:</strong></label>
                                    <p className="form-control-plaintext">{selectedVendorCredentials.vendorName}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><strong>رقم الهاتف:</strong></label>
                                    <p className="form-control-plaintext">{selectedVendorCredentials.phoneNumber}</p>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label"><strong>كلمة المرور الجديدة:</strong></label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="أدخل كلمة مرور جديدة"
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowCredentialsModal(false);
                                        setNewPassword('');
                                        setSelectedVendorId(null);
                                    }}
                                >
                                    إغلاق
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={resetVendorPassword}
                                >
                                    تحديث كلمة المرور
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
                </>
            )}
        </div>
    );
}

export default Vendors;
